<template>
  <div>
    <v-toolbar dense flat>
      <v-app-bar-nav-icon to="/account/home" small>
        <v-icon>home</v-icon>
      </v-app-bar-nav-icon>

      <v-toolbar-title>Account</v-toolbar-title>

      <v-spacer></v-spacer>

      <v-btn text color="teal" class="mr-2" dark to="/account/category/list">
        Category List
      </v-btn>

      <v-btn text color="teal" dark to="/account/list">
        Account List
      </v-btn>

      <!-- <v-btn text color="teal" dark to="/account/category/list">Category</v-btn> -->
    </v-toolbar>
    <v-divider></v-divider>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "account",
  data() {
    return {};
  },
  created() {}
};
</script>
